import Vue from 'vue';
import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader
// import 'material-design-icons-iconfont/dist/material-design-icons.css';

let Vuetify = window.Vuetify;
Vue.use(Vuetify);

// Preserve Vuetify's original component before replacing its global registration.
// The wrapper keeps every existing v-pagination call compatible while adding page jump.
const RegisteredPagination = Vue.options.components.VPagination;
const BasePagination = RegisteredPagination.options.extendedBasePagination || RegisteredPagination;
Vue.component('VPagination', {
  name: 'ExtendedPagination',
  // Keep the original constructor available when this module is reloaded by HMR.
  extendedBasePagination: BasePagination,
  inheritAttrs: false,
  props: BasePagination.options.props,
  data() {
    return {
      jumpPage: this.value || 1,
      showPageJump: false
    };
  },
  computed: {
    paginationListeners() {
      return Object.assign({}, this.$listeners, {
        input: this.handlePaginationInput
      });
    }
  },
  watch: {
    value(value) {
      this.jumpPage = value;
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleWindowResize);
    this.$nextTick(this.updatePageJumpVisibility);
  },
  updated() {
    this.$nextTick(this.updatePageJumpVisibility);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  },
  methods: {
    handlePaginationInput(page) {
      this.jumpPage = page;
      this.$emit('input', page);
    },
    handleJump() {
      if (this.disabled || this.length < 1) {
        return;
      }

      let page = parseInt(this.jumpPage, 10);
      if (isNaN(page)) {
        this.jumpPage = this.value;
        return;
      }

      page = Math.max(1, Math.min(page, this.length));
      this.jumpPage = page;

      if (page !== this.value) {
        // Reuse the original input contract so v-model and existing handlers both run.
        this.$emit('input', page);
      }
    },
    handleJumpKeyup(event) {
      if (event.keyCode === 13) {
        this.handleJump();
      }
    },
    handleWindowResize() {
      // Wait until the original pagination recalculates its responsive items.
      this.$nextTick(this.updatePageJumpVisibility);
    },
    updatePageJumpVisibility() {
      const pagination = this.$refs.pagination;
      const items = pagination && pagination.items;
      const showPageJump = Array.isArray(items) && items.some((item) => item === '...');

      if (showPageJump !== this.showPageJump) {
        this.showPageJump = showPageJump;
      }
    }
  },
  render(h) {
    const children = [
      h(BasePagination, {
        ref: 'pagination',
        props: this.$props,
        attrs: this.$attrs,
        on: this.paginationListeners
      })
    ];

    if (this.showPageJump) {
      children.push(
        h(
          'div',
          {
            style: {
              display: 'flex',
              alignItems: 'center',
              flexShrink: 0,
              gap: '8px'
            }
          },
          [
            h('span', { style: { color: '#606266', whiteSpace: 'nowrap' } }, ['Go to']),
            h('v-text-field', {
              style: { width: '44px', marginTop: 0 },
              attrs: {
                inputmode: 'numeric',
                pattern: '[0-9]*',
                'aria-label': 'Go to page'
              },
              props: {
                value: this.jumpPage,
                type: 'text',
                dense: true,
                singleLine: true,
                hideDetails: true,
                height: 32,
                disabled: this.disabled
              },
              on: {
                input: (value) => {
                  this.jumpPage = value;
                },
                keyup: this.handleJumpKeyup
              }
            })
          ]
        )
      );
    }

    return h(
      'div',
      {
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexWrap: 'wrap',
          gap: '12px'
        }
      },
      children
    );
  }
});

let primaryColorMap = {
  ccs: '#3c8dbc',
  hwy: '#2245b2',
  dbm: '#4421be',
  aik: '#332ee8'
};
export default new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: primaryColorMap[process.env.VUE_APP_ACTOR],
        secondary: '#4caf50',
        tertiary: '#495057',
        accent: '#82B1FF',
        error: '#f55a4e',
        info: '#00d3ee',
        success: '#5cb860',
        warning: '#ffa21a'
      }
    }
  },
  icons: {
    iconfont: 'mdi'
  },
  iconfont: 'md'
});
